export default __webpack_public_path__ + "static/media/PersImg10.fcb25745.jpg";